export enum NumFormattingType {
  SHORT,
  MEDIUM,
  LONG
}

export type SiType = {
  value: number;
  threshold: number;
  short: string;
  medium: string;
  long: string;
};
